import React, { useEffect, useState } from 'react';
import { Container, Image, InputGroup, FormControl, Button } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import sampleSchoolLogo from "../../../assets/images/common/sampleSchoolLogo.png";

const PageInfoStatus = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const userData = sessionStorage.getItem('user');
  const userObj = userData ? JSON.parse(userData) : {};
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const logoUrl = userObj.logo ? `${baseUrl}/uploads/get-image/${userObj.logo}` : sampleSchoolLogo;

  const [students, setStudents] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const res = await axios.post(`${baseUrl}/students/`, {
        academic_year_id: Number(userObj.academic_year_id),
        status: "A",
        school_id: Number(userObj.school_id),
        action: "READ"
      });

      const data = res.data || [];

      const formatted = data.map(student => ({
        label: `${student.admission_number}`,
        value: student.admission_number,
        student_id: student.student_id,
        ...student
      }));

      setStudents(formatted);
    } catch (err) {
      console.error("Error fetching students:", err.response?.data || err.message);
    }
  };

  useEffect(() => {
    if (!searchText.trim()) {
      setSuggestions([]);
      return;
    }

    const input = searchText.trim().toLowerCase();

    const filtered = students.filter(student => {
      const fullName = `${student.student_first_name} ${student.student_last_name}`.toLowerCase();
      return (
        student.admission_number?.toLowerCase().includes(input) ||
        fullName.includes(input)
      );
    });

    setSuggestions(filtered);
  }, [searchText, students]);

  const handleSearch = () => {
    const input = searchText.trim().toLowerCase();
    if (!input) return;

    const exactMatch = students.find(student => {
      const fullName = `${student.student_first_name} ${student.student_last_name}`.toLowerCase();
      return (
        student.admission_number?.toLowerCase() === input ||
        student.student_first_name?.toLowerCase() === input ||
        student.student_last_name?.toLowerCase() === input ||
        fullName === input
      );
    });

    if (exactMatch) {
      navigate(`/StudentDetails/${exactMatch.student_id}`);
    } else {
      const partialMatches = students.filter(student => {
        const fullName = `${student.student_first_name} ${student.student_last_name}`.toLowerCase();
        return (
          student.admission_number?.toLowerCase().includes(input) ||
          student.student_first_name?.toLowerCase().includes(input) ||
          student.student_last_name?.toLowerCase().includes(input) ||
          fullName.includes(input)
        );
      });

      navigate(`/HistoryReports`, { state: { matchedStudents: partialMatches } });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSuggestionClick = (studentId) => {
    navigate(`/StudentDetails/${studentId}`);
    setSearchText('');
    setSuggestions([]);
  };

  return (
    <Container fluid style={{
      padding: '10px 20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '6px'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap'
      }}>
        {/* Logo */}
        <div style={{ marginRight: '15px' }}>
          <Image
            src={logoUrl}
            alt="School Logo"
            fluid
            rounded
            style={{ maxHeight: '50px' }}
          />
        </div>

        {/* School Name */}
        <div style={{ margin: '0 10px', whiteSpace: 'nowrap' }}>
          <h5 style={{ margin: 0 }}>{userObj.school_name} ({userObj.branch})</h5>
        </div>

        {/* Search Box with Suggestions */}
        <div style={{ margin: '0 10px', minWidth: '250px', flex: 1, position: 'relative' }}>
          <InputGroup size="sm">
            <FormControl
              placeholder="Adm No / Name"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <Button variant="outline-secondary" onClick={handleSearch}>
              <FaSearch />
            </Button>
          </InputGroup>

          {/* Suggestions Dropdown */}
          {suggestions.length > 0 && (
            <div style={{
              border: '1px solid #ccc',
              borderTop: 'none',
              maxHeight: '200px',
              overflowY: 'auto',
              backgroundColor: 'white',
              position: 'absolute',
              zIndex: 1000,
              width: '100%'
            }}>
              {suggestions.map((student, idx) => (
                <div
                  key={idx}
                  onClick={() => handleSuggestionClick(student.student_id)}
                  style={{
                    padding: '8px 10px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eee',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {student.admission_number} - {student.student_first_name} {student.student_last_name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default PageInfoStatus;
